import { Profile } from "./profile.model";

export class Notification {
  id: string;
  sender: Profile;
  subscriber: Profile;
  senderModel: string;
  activity: any;
  read: boolean;
  createdAt: string;
  updatedAt: string;
}
